import { ref } from "vue";
import { defineStore } from "pinia";
import { useToast } from "vue-toastification";
import apiClient from "@/axios";

export const usePepTransactionStore = defineStore("PepTransaction", () => {
    const pepTransactionEntity = ref([]);
    const toast = useToast();

    async function fetchPaymentResult(invoiceId) {
        try {
            const response = await apiClient.get(`/PepTransaction/result?invoiceId=${invoiceId}`)
            return response.data;
        } catch (error) {
            console.error("Error fetching PepTransaction:", error);
        }
    }
    async function requestPepTransaction(payload) {
        try {
            const body = Array.isArray(payload)
                ? { productIds: payload }
                : (payload && Array.isArray(payload.productIds))
                    ? payload
                    : null;

            if (!body) {
                toast.error("فرمت ورودی تراکنش پرداخت نامعتبر است");
                throw new Error("Invalid PepTransaction request payload");
            }

            const response = await apiClient.post(`/PepTransaction/request`, body);

            return response.data;
        } catch (error) {
            console.error("Error fetching pepTransaction:", error);
            toast.error("خطا در ایجاد تراکنش پرداخت");
        }
    }
    return {
        pepTransactionEntity,
        fetchPaymentResult,
        requestPepTransaction
    }
})